export default "__VITE_ASSET__e0fJN6gg__"